import BaseContentDetailsDetailsSubPageView from "scripts/views/baseContentDetailsDetailsSubPageView";
import templateContentDetailsVideoPageDetailsSubPage from "templates/contentDetailsVideoPageDetailsSubPage.hbs";

class ContentDetailsVideoPageDetailsSubPageView extends BaseContentDetailsDetailsSubPageView {
  get template() {
    return templateContentDetailsVideoPageDetailsSubPage;
  }
}

export default ContentDetailsVideoPageDetailsSubPageView;
